(function () {
  'use strict';

  /* @ngdoc object
   * @name print
   * @description
   *
   */
  angular
    .module('print', [
      'ui.router'
    ]);
}());
